import { combineEpicsIsolated } from 'utils/epicRegistry'

import groupSettingsAssignEpics from './Assign/epics'
import groupSettingsTableEpics from './Table/epics'
import groupSettingsWizardEpics from './Wizard/epics'

export default combineEpicsIsolated(
  groupSettingsWizardEpics,
  groupSettingsTableEpics,
  groupSettingsAssignEpics
)
